import type { IndustryStitch } from "@/lib/types/industry";

export function IndustryStitchPanel({
  companyName,
  stitch,
}: {
  companyName: string;
  stitch: IndustryStitch;
}) {
  return (
    <div className="rounded-lg border border-sky-500/30 bg-sky-500/5 p-4">
      <h3 className="mb-2 text-sm font-semibold text-sky-300">
        How this affects {companyName}
      </h3>
      <p className="text-sm leading-relaxed text-slate-100">{stitch.summary}</p>
    </div>
  );
}
